// 物业公告管理
import request from '@/utils/httpRequest'

export function queryById (id) {
    return request({
        url: '/daily/wuyeDailyNotice/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/daily/wuyeDailyNotice/startFlow',
        method: 'post',
        data: params
    })
}